// extracted by mini-css-extract-plugin
export default {"overlay":"Home_overlay__8C54b","navigation":"Home_navigation__iznK7"};